<div class="navbar-container" [class.expanded]="showMenu" (clickOutside)="clickedOutside($event)"  style="height:auto;">
    <div class="container-xl">
        <nav class="navbar navbar-light">
            <a class="navbar-brand-link" href="/pep/en" (click)="fnShowMenu(false)">
                <img class="my-0 mr-md-auto navbar-brand" src="/pep/images/en/PEP EN Logo.svg" alt="Copeia">
            </a>
            <div class="navbar-toggler collapsed" (click)="fnShowMenu(true)">
                <img src="/pep/Menu Buton.svg" alt="" />
            </div>
        </nav>
    </div>
    <div class="collapse navbar-collapse" id="navbarResponsive" [class.show]="showMenu">
        <div class="navbar-with-menu">
            <div class="navbar-with-sticky">
                <div class="container-xl">
                    <nav class="navbar navbar-light">
                        <a class="navbar-brand-link" href="/pep/en">
                            <img class="my-0 mr-md-auto navbar-brand" src="/pep/images/en/PEP EN Logo.svg" alt="Copeia">
                        </a>
                        <div class="navbar-toggler collapsed" (click)="fnShowMenu(false)">
                            <img src="/pep/Menu Buton close.svg" alt="" />
                        </div>
                    </nav>
                    <div class="nav-menu">
                        <div class="menu-items">
                            <div class="fm-patient">
                                <ul>
                                    <li>
                                        <a href="/pep/en" (click)="fnShowMenu(false)">HOME</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="fm-fachkreise">
                                <ul>
                                    <li>
                                        <a href="/pep/en/search" (click)="fnShowMenu(false)">PEP Search (DocCheck required)</a>
                                    </li>
                                    <li>
                                        <a href="/pep/en/explorer" (click)="fnShowMenu(false)">PEP Explorer</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="fm-researcher">
                                <ul>
                                    <li>
                                        <a href="/pep/en/doccheck-info" (click)="fnShowMenu(false)">DocCheck Registration</a>
                                    </li>
                                    <li>
                                        <a href="https://copeia.info/home-eng" (click)="fnShowMenu(false)">About Copeia</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
